import ApplicationAdapter from 'eflex/adapters/application';

export default class NodeRedAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
